
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1sxt8_gdpod_189",
  "drawer": "awsui_drawer_1sxt8_gdpod_193",
  "has-close-action": "awsui_has-close-action_1sxt8_gdpod_226",
  "position-absolute": "awsui_position-absolute_1sxt8_gdpod_229",
  "placement-end": "awsui_placement-end_1sxt8_gdpod_229",
  "position-sticky": "awsui_position-sticky_1sxt8_gdpod_229",
  "position-fixed": "awsui_position-fixed_1sxt8_gdpod_229",
  "placement-start": "awsui_placement-start_1sxt8_gdpod_232",
  "placement-top": "awsui_placement-top_1sxt8_gdpod_235",
  "placement-bottom": "awsui_placement-bottom_1sxt8_gdpod_238",
  "with-footer": "awsui_with-footer_1sxt8_gdpod_241",
  "position-static": "awsui_position-static_1sxt8_gdpod_245",
  "content": "awsui_content_1sxt8_gdpod_248",
  "header": "awsui_header_1sxt8_gdpod_276",
  "hide-close-action": "awsui_hide-close-action_1sxt8_gdpod_290",
  "with-additional-action": "awsui_with-additional-action_1sxt8_gdpod_294",
  "with-runtime-context": "awsui_with-runtime-context_1sxt8_gdpod_302",
  "with-toolbar": "awsui_with-toolbar_1sxt8_gdpod_305",
  "header-actions": "awsui_header-actions_1sxt8_gdpod_330",
  "close-action": "awsui_close-action_1sxt8_gdpod_336",
  "content-with-paddings": "awsui_content-with-paddings_1sxt8_gdpod_342",
  "footer": "awsui_footer_1sxt8_gdpod_349",
  "is-sticky": "awsui_is-sticky_1sxt8_gdpod_355",
  "test-utils-drawer-content": "awsui_test-utils-drawer-content_1sxt8_gdpod_363",
  "hidden": "awsui_hidden_1sxt8_gdpod_367",
  "focus-trap": "awsui_focus-trap_1sxt8_gdpod_371",
  "backdrop": "awsui_backdrop_1sxt8_gdpod_375",
  "backdrop-fixed": "awsui_backdrop-fixed_1sxt8_gdpod_379",
  "backdrop-absolute": "awsui_backdrop-absolute_1sxt8_gdpod_382"
};
  